import { Controller } from "@hotwired/stimulus"

// Shows and hides one content target from a toggle button. The button
// reports its state through aria-expanded; an optional icon turns by the
// `open` classes (rotate-180 when none are given) and an optional text
// target swaps between the closed and open labels.
export default class extends Controller {
  static targets = ["content", "button", "icon", "text"]
  static classes = ["open"]
  static values = {
    openText: { type: String, default: "Show less" },
    closedText: { type: String, default: "Show details" },
  }

  declare readonly contentTarget: HTMLElement
  declare readonly hasButtonTarget: boolean
  declare readonly buttonTarget: HTMLElement
  declare readonly hasIconTarget: boolean
  declare readonly iconTarget: HTMLElement
  declare readonly hasTextTarget: boolean
  declare readonly textTarget: HTMLElement
  declare readonly hasOpenClass: boolean
  declare readonly openClasses: string[]
  declare openTextValue: string
  declare closedTextValue: string

  toggle() {
    const open = this.contentTarget.hidden
    this.contentTarget.hidden = !open

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", String(open))
    }
    if (this.hasIconTarget) {
      const classes = this.hasOpenClass ? this.openClasses : ["rotate-180"]
      classes.forEach((cls) => this.iconTarget.classList.toggle(cls, open))
    }
    if (this.hasTextTarget) {
      this.textTarget.textContent = open
        ? this.openTextValue
        : this.closedTextValue
    }
  }
}
